export const BULK_UPLOAD_COLUMNS = [
  'Product Name',
  'Product Description',
  'More Details',
  'Category',
  'Selling Price',
  'Stock Quantity',
  'Sub-category',
  'Product Variations',
  'Colour',
  'Size',
  'Cost Price',
  'Discounted Price',
  'SKU',
  'Weight',
] as const;

export const BULK_UPLOAD_REQUIRED_COLUMNS = [
  'Product Name',
  'Product Description',
  'More Details',
  'Category',
  'Selling Price',
  'Stock Quantity',
] as const;

export const BULK_UPLOAD_OPTIONAL_COLUMNS = BULK_UPLOAD_COLUMNS.filter(
  (column) =>
    !(BULK_UPLOAD_REQUIRED_COLUMNS as readonly string[]).includes(column)
);

export const BULK_UPLOAD_MAX_FILE_SIZE_MB = 10;

export const BULK_UPLOAD_SAMPLE_ROW: Record<string, string> = {
  'Product Name': 'Ankara Tote Bag',
  'Product Description': 'Handmade tote in wax print cotton',
  'More Details': 'Lined interior, 2 pockets',
  Category: '',
  'Selling Price': '18500',
  'Stock Quantity': '24',
  'Sub-category': '',
  'Product Variations': 'Colour|Size',
  Colour: 'Green',
  Size: 'M',
  'Cost Price': '11000',
  'Discounted Price': '16000',
  SKU: 'SLT-TOTE-001',
  Weight: '0.6',
};

function escapeCsvCell(value: string): string {
  if (/[",\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

function rowsToCsv(rows: Record<string, string>[]): string {
  const header = BULK_UPLOAD_COLUMNS.join(',');
  const body = rows
    .map((row) =>
      BULK_UPLOAD_COLUMNS.map((column) =>
        escapeCsvCell(row[column] ?? '')
      ).join(',')
    )
    .join('\n');
  return `${header}\n${body}`;
}

export function downloadBulkUploadCsv(
  filename: string,
  rows: Record<string, string>[]
): void {
  const content = rowsToCsv(rows);
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

export function downloadBulkUploadTemplate(): void {
  downloadBulkUploadCsv('sellyt-product-template.csv', [
    Object.fromEntries(BULK_UPLOAD_COLUMNS.map((column) => [column, ''])),
  ]);
}

export function downloadBulkUploadSample(): void {
  downloadBulkUploadCsv('sellyt-product-sample.csv', [BULK_UPLOAD_SAMPLE_ROW]);
}
